import React, { useState, useEffect } from 'react';
import { SingleInput } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { CASE_STATUS_INVALID } from '../../../../item/ItemRecruitmentContractor';
import { CancelSubmitButton } from '../../Res/BaseButton';
import moment from 'moment';
import { toRevise } from './ReviseSOPTools';
import { getOnlyDate } from '../../../../item/ItemTools';

/**
 * 作廢此 “派遣案件”
 * @param {*} param0 
 */
export function ReviseInvalid({ item, action, view, vw_status, setIsLoading }) {
    const [mItem, setItem] = useState({})

    const [caseComment, setCaseComment] = useState("")
    const [caseInvalidDate] = useState(moment(new Date()).format('YYYY-MM-DD'))

    const description = "作廢此 “派遣案件”"

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setItem(item)
        }
    }, [item])

    function toCancel() {
        action(view)
    }

    function toAction() {
        toRevise(mItem, "此派遣案件已作廢", {
            setIsLoading,
            description: getOnlyDate() + " 作廢此案件",
            comment: caseComment,
            caseInvalidDate,
            caseStatus: CASE_STATUS_INVALID
        })
    }
    var superTitle = description
    var title = ""
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {vw_status}
                    
                    <div className="col-md-3">
                                        <p className="col-md-12">
                                            注意：作廢後無法復原！</p>
                                        <p className="col-md-12">
                                            提示：作廢後，不列入招募績效統計！</p>
                                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
                </div>
            </div>
        </>

    var footer =
        <div className="row text-right ">
            <div className="col-sm-12">
                <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
            </div>
        </div>

    return (
        <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    )
}